import { RnbCalculatorPayload } from 'typings'
import { Gift, GIFT_APPLICATION } from '../../../typings'

export function toAPIGift<T>(
  gift: Gift<T>
): Pick<RnbCalculatorPayload, 'skusGift' | 'activateGiftsMultiplier'> {
  return {
    skusGift: {
      quantitySelectable: gift.maxQuantity,
      gifts: gift.items,
    },
    activateGiftsMultiplier: gift.application === GIFT_APPLICATION.PER_ITEM,
  }
}
